module.exports = __webpack_public_path__ + "static/media/Teil_3_Neu.71b03930.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_3_Neu.ogv
// module id = 121
// module chunks = 0